"use strict"

import React, { useReducer, useState } from "react"
import { FormGroup, Button, Modal, Form } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"

import { RequiredFieldWarning } from "../internationalization/LocaleFormatted"
import { displayRef } from "./utils"
import AreYouSureModal from "./AreYouSureModal"
import LoaderGif from "./LoaderGif"

export default function SingleColumnForm(props) {
  const { resources, initialState, initialWarningState, formReducer, ModalBody } = props
  const intl = useIntl()

  const [state, dispatch] = useReducer(formReducer, {
    ...initialState,
    ...initialWarningState,
  })
  const { isLoading } = state

  const updateFormValue = (e, field, value, warning, warningField) => {
    e.preventDefault()
    dispatch({ type: "field", field: field, value: value })
    if (warning) {
      dispatch({ type: "field", field: warningField, value: false })
    }
  }

  const [data, setData] = useState({})
  const [verifySubmitModal, setVerifySubmitModal] = useState(false)

  const validateForm = (e) => {
    displayRef("single_column_form_gif", true)
    e.preventDefault()
    dispatch({ type: "submit" })

    let validSubmission = true
    resources.forEach((field) => {
      if (state[field["field"]] === "" || !state[field["field"]]) {
        validSubmission = false
        dispatch({ type: "field", field: `${field["field"]}Warn`, value: true })
      }
    })

    if (validSubmission) {
      let data = {}
      resources.forEach((field) => (data[field["field"]] = state[field["field"]]))
      setData(data)
      setVerifySubmitModal(true)
      displayRef("single_column_form_modal", false)
    } else {
      displayRef("single_column_form_gif", false)
      dispatch({ type: "invalid-form" })
    }
  }

  const submitForm = (e, data) => {
    if (e) {
      e.preventDefault()
    }
    setVerifySubmitModal(false)
    displayRef("single_column_form_modal", true)
    dispatch({ type: "invalid-form" })
    props.submitData(data, "single_column_form_gif")
  }

  const cancelForm = (e) => {
    if (e) {
      e.preventDefault()
    }
    setVerifySubmitModal(false)
    displayRef("single_column_form_gif", false)
    displayRef("single_column_form_modal", true)
    dispatch({ type: "invalid-form" })
  }

  return (
    <React.Fragment>
      {verifySubmitModal && (
        <AreYouSureModal
          show={verifySubmitModal}
          onHide={(e) => cancelForm(e)}
          data={data}
          modalBody={<ModalBody data={data} title={props.confirmation_title} resources={resources} />}
          submitForm={submitForm}
          cancelForm={cancelForm}
        />
      )}
      <Modal
        size={"lg"}
        dialogClassName={"common-modal"}
        show={props.show}
        onHide={props.onHide}
        style={{ overflowX: "scroll", overflowY: "scroll" }}
        backdrop={"static"}
        id={"single_column_form_modal"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div>
              <div className="col-12">
                <h3 style={{ marginTop: 0 }}>
                  <span className={`fa ${props.page_glyph}`} style={{ marginRight: "20px" }} />
                  <FormattedMessage
                    id={`${props.page_translation_id}`}
                    description={`${props.label} Page Title`}
                  />
                </h3>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LoaderGif id={"single_column_form_gif"} />
          {props.warning && (
            <div style={{ marginBottom: "25px" }}>
              <p className={"error-message"}>
                <FormattedMessage id={"general.server.error"} description={"Server Error Message"} />:
              </p>
              <p className={"error-message"}>{props.warning}</p>
            </div>
          )}
          <Form id={"uploadDataRunForm"}>
            {resources.map((resource) => {
              return (
                <div key={resource["field"]}>
                  <FormGroup controlId={`form${resource["field"]}Selection`} style={{ display: "flex" }}>
                    <label className="col-4 col-form-label">
                      <FormattedMessage id={resource.label} description={`${resources["field"]} label`} />:
                    </label>
                    <div className="col-8" style={{ display: "flex" }}>
                      {!["textarea", "dropdown"].includes(resource["type"]) && (
                        <input
                          className={"input-full-width"}
                          type={resource["type"]}
                          disabled={resource["disabled"]}
                          value={state[resource["field"]] || ""}
                          onChange={(e) =>
                            updateFormValue(
                              e,
                              resource["field"],
                              e.target.value,
                              state[`${resource["field"]}Warn`],
                              `${resource["field"]}Warn`,
                            )
                          }
                          placeholder={intl.formatMessage({ id: resource.label })}
                        />
                      )}
                      {resource["type"] === "textarea" && (
                        <textarea
                          className={"textarea-full-width"}
                          value={state[resource["field"]] || ""}
                          placeholder={intl.formatMessage({ id: resource.label })}
                          onChange={(e) =>
                            updateFormValue(
                              e,
                              resource["field"],
                              e.target.value,
                              state[`${resource["field"]}Warn`],
                              `${resource["field"]}Warn`,
                            )
                          }
                        />
                      )}
                      {resource["type"] === "dropdown" && (
                        <select
                          className={"dropdown-full-width"}
                          name={resource["field"]}
                          disabled={Object.keys(resource).includes("disabled") ? resource["disabled"] : false}
                          value={state[resource["field"]] || ""}
                          onChange={(e) => {
                            if (resource["on_select"]) {
                              resource["on_select"](e.target.value)
                            }
                            updateFormValue(
                              e,
                              resource["field"],
                              e.target.value,
                              state[`${resource["field"]}Warn`],
                              `${resource["field"]}Warn`,
                            )
                          }}
                        >
                          <option value="">
                            {intl.formatMessage({
                              id: "general.dropdown.please.select",
                            })}
                          </option>
                          {resource["options"].map((opt, idx) => {
                            return (
                              <option key={idx} value={opt} className={"text-center"}>
                                {opt}
                              </option>
                            )
                          })}
                        </select>
                      )}
                      &nbsp;&nbsp;
                      <RequiredFieldWarning warning={state[`${resource["field"]}Warn`]} />
                    </div>
                  </FormGroup>
                </div>
              )
            })}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <FormGroup controlId={"formCloseButton"} style={{ marginRight: "auto" }}>
            <Button
              type={"reset"}
              variant={"outline-primary"}
              disabled={isLoading}
              onClick={(e) => {
                e.preventDefault()
                dispatch({ type: "clear" })
                props.clearWarning ? props.clearWarning() : null
                props.onHide()
              }}
            >
              <FormattedMessage id={"general.closeButton"} description={"Close Button For Form"} />
            </Button>
          </FormGroup>
          <FormGroup controlId={"formClearButton"} style={{ marginLeft: "auto" }}>
            <Button
              type={"reset"}
              variant={"danger"}
              disabled={isLoading}
              onClick={(e) => {
                e.preventDefault()
                dispatch({ type: "clear" })
                props.clearWarning ? props.clearWarning() : null
              }}
            >
              <FormattedMessage id={"general.clearButton"} description={"Clear Button For Form"} />
            </Button>
            &nbsp;
            <Button type={"submit"} variant={"primary"} disabled={isLoading} onClick={(e) => validateForm(e)}>
              <FormattedMessage id={"general.submitButton"} description={"Submit Button For Form"} />
            </Button>
          </FormGroup>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}

export function SingleColumnConfirmationBody(props) {
  const { data, resources } = props

  return (
    <>
      <div>
        <h5 className={"text-center"}>
          <FormattedMessage id={props.title} />
        </h5>
      </div>
      {resources.map((item, idx) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }} key={`item${idx}`}>
            <h6>
              <FormattedMessage id={item["label"]} />:
            </h6>
            &nbsp;&nbsp;
            <p style={{ margin: "0px" }}>{data[item["field"]]}</p>
          </div>
        )
      })}
    </>
  )
}
